export default "__VITE_ASSET__Bt2l6Lsd__$_?no-inline__"